module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_JoinBanner Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_JoinBanner', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/joinBanner.js
// module id = 819
// module chunks = 4